import { success } from "toastr";
import {
  FETCH_MODULE,
  FETCH_MODULE_SUCCESS,
  FETCH_MODULE_FAILURE,
  FETCH_MODULE_PROJECT_CLIENT_SERVICE,
  FETCH_MODULE_PROJECT_CLIENT_SERVICE_SUCCESS,
  FETCH_MODULE_PROJECT_CLIENT_SERVICE_FAILURE,  
  FETCH_MODULE_PROJECT_CLIENT_SERVICE_CLEAR,
  SAVE_MODULE,
  SAVE_MODULE_SUCCESS,
  SAVE_MODULE_FAILURE,
  CHANGE_MODULE_STATUS,
  CHANGE_MODULE_STATUS_SUCCESS,
  CHANGE_MODULE_STATUS_FAILURE
} from "./actionTypes";

const initialState = {
  module: [],
  moduleProjectClientService:'',
  loading: false,
  error: null,
  success:false
};

const timesheetSetupModuleReducer = (state = initialState, action) => {
 
  switch (action.type) {
    case FETCH_MODULE:
      return { ...state, loading: true };
    case FETCH_MODULE_SUCCESS:
      return { ...state, loading: false, module: action.payload.data};
    case FETCH_MODULE_FAILURE:
      return { ...state, loading: false, error: action.payload };    
    case FETCH_MODULE_PROJECT_CLIENT_SERVICE:
      return { ...state, loading: true, success: false };
    case FETCH_MODULE_PROJECT_CLIENT_SERVICE_SUCCESS:
      return { ...state, loading: false, success: false, moduleProjectClientService:action.payload.data[0] };    
    case FETCH_MODULE_PROJECT_CLIENT_SERVICE_CLEAR:
      return { ...state, loading: false, success: false, moduleProjectClientService: '' };     
    case FETCH_MODULE_PROJECT_CLIENT_SERVICE_FAILURE:
      return { ...state, loading: false, success: false, error: action.payload };
    case CHANGE_MODULE_STATUS:
      return { ...state, loading: true, error: null, success: false };
    case CHANGE_MODULE_STATUS_SUCCESS:
      return { ...state, loading: false, success: true };
    case CHANGE_MODULE_STATUS_FAILURE:
      return { ...state, loading: false, error: action.payload, success: false };
    case SAVE_MODULE:
      return { ...state, loading: true, success:false, error: null };    
    case SAVE_MODULE_SUCCESS:
      return { ...state, loading: false, success:true, deductionData: action.payload, error: null };
    case SAVE_MODULE_FAILURE:
      return { ...state, loading: false, success:false, error: action.payload };           
    default:
      return state;
  }
};

export default timesheetSetupModuleReducer;
